export enum AnalysisExecutionStatus {
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED'
}

export interface AnalysisWorkspaceConfiguration {
  analysisWorkspaceConfigurationId: string;
  name: string;
  status: string;
  latestWorkspaceExecutionStatus: AnalysisExecutionStatus | null;
  createdAt: string;
  updatedAt: string;
}

export interface QueryAnalysisWorkspaceConfigurationsRequest {
  sortBy?: string;
  sortDirection?: 'asc' | 'desc';
  maxResults?: number;
  nextToken?: string | null;
}

export interface QueryAnalysisWorkspaceConfigurationsResponse {
  analysisWorkspaceConfigurations: AnalysisWorkspaceConfiguration[];
  nextToken: string | null;
  totalResults: number;
}
